import { takeEvery, takeLatest, call, put, select } from 'redux-saga/effects'
import axios from 'axios'
import { FETCH_MATCHED_TRUCKS, SET_MATCHED_TRUCKS, FETCH_TRUCKS_WITH_FILTER, SET_TRUCKS, 
  ADD_MESSAGE, UPDATED_MATCHED_TRUCK_BID, ADD_DAT_TRUCK_TO_CARRIER } from '../actionTypes'
import { getHistoricLoads, getSelectedLoad } from '../rootReducer'


// function that makes the api request and returns a Promise for response
function fetchTrucks(loadId) {
  return axios({
    method: "get",
    url: `/api/loads/${loadId}/trucks`,
    debug: true
  })
}


function fetchTrucksWithFilter(args) {
    const request = {
        method: 'get',
        url: '/api/trucks?isFiltered=true'
    }

    request.params = {}

    for (let key in args) {
        if (args[key]) {
            request.params[key] = args[key]
        }
    }

    return axios(request) || []
}

function addDATTruckToCarrier(truck) {
  return axios({
    method: "post",
    url: `/api/trucks`,
    data: truck
  })
}

function fetchDoNotUseCarriersMCs(customer_id) {
  let url = `/api/customers/${customer_id}/restricted_carriers`
  

  return axios({
    method: "get",
    url: url
  })
}

function* filterDoNotUseCarriers(trucks, customer_id) {
  let results = trucks
  try {
    // here we want to check the customer to see if there are certain carriers we cannot use
    if (trucks && trucks.length && customer_id) {
      const doNotUseCarriersResponse = yield call(fetchDoNotUseCarriersMCs, customer_id)
      if (doNotUseCarriersResponse && doNotUseCarriersResponse.data && doNotUseCarriersResponse.data.length) {
        const mcs = doNotUseCarriersResponse.data.map(c => c.mc).filter(mc => mc !== null)
        results = trucks.filter(t => (! mcs.includes(t.carrier.mc)))
      }
    }
  } catch (excFT) {
    console.err(excFT)
  }
  return results
}


// worker saga: makes the api call when watcher saga sees the action
function* workerFetchMatchedTrucks(payload) {
  try {
    yield put({ type: SET_MATCHED_TRUCKS, payload: {trucks: [], historicLoads: []} })

    const response = yield call(fetchTrucks, payload.loadId)
    let trucks = (response.data || [])
    const historicLoads = yield select(getHistoricLoads)  

    const selectedLoad = yield select(getSelectedLoad)
    trucks = yield call(filterDoNotUseCarriers, trucks, selectedLoad.customer_id)
    yield put({ type: SET_MATCHED_TRUCKS, payload: {trucks: trucks, historicLoads, selectedLoad}})

  
  } catch (error) {
    // dispatch a failure action to the store with the error
    console.log("error on truck saga ", error)
    //TODO: should send error to screen as message
    // this is resetting the tables to not show the loading message
    yield put({ type: SET_MATCHED_TRUCKS, payload: {trucks: [], historicLoads: []} })
  }
}


function* workerFetchTrucksWithFilterSaga(action) {
    try {
        // Wipe out table before re-rendering, so loading indicator does not interfere with table animation
        yield put({ type: SET_TRUCKS, trucks: null })
        const response = yield call(fetchTrucksWithFilter, action.payload)

        if (response) {
            const trucks = response.data
            yield put({ type: SET_TRUCKS, trucks })

            if (trucks.length === 0) {
                yield put({type: ADD_MESSAGE, message: 'No matching trucks found!'})
            }
        }

    } catch (error) {
        console.log('workerFetchTrucksWithFilterSaga error: ', error)
    }
}

function workerMatchedTruckBidSaga(action) {
  //console.log("hey we got a bid that came in", action)

  // loop through the bids to add a bid on to the matched truck
  //TODO: Implement this later
}

function* workerAddDATTruckToCarrierSaga(action) {
  yield call(addDATTruckToCarrier, action.truck)

}

// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* watchFetchMatchedTrucks() {
    yield takeLatest(FETCH_MATCHED_TRUCKS, workerFetchMatchedTrucks)
}

export function* watchFetchTrucksWithFilterSaga() {
    yield takeLatest(FETCH_TRUCKS_WITH_FILTER, workerFetchTrucksWithFilterSaga)
}

export function* watchMatchedTruckBidSaga() {
    yield takeEvery(UPDATED_MATCHED_TRUCK_BID, workerMatchedTruckBidSaga)

}

export function* watchAddDATTruckToCarrierSaga() {
    yield takeEvery(ADD_DAT_TRUCK_TO_CARRIER, workerAddDATTruckToCarrierSaga)
}


